<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[{'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listePaiementSurFacture.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listePaiementSurFacture.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="hasError">
        <error-msg-component :messages="errors"
                             :error="hasError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="closeErrorMsg"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[{'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}]">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.refPaiement')">
          <b-input v-model="newCritereRecherche.referencePaiement"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.commentaire')">
          <b-input v-model="newCritereRecherche.commentaire"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.bonAPayer')">
          <b-select v-model="newCritereRecherche.bonAPayer">
            <option :value="null"></option>
            <option :value="true"> {{ $t('listePaiementSurFacture.filtre.yes') }}
            </option>
            <option :value="false"> {{ $t('listePaiementSurFacture.filtre.no') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.validateur')">
          <qd-taginput v-if="validateurTags"
                      v-model="validateurSelected"
                      :data="validateurTags"
                      type="is-primary"
                      icon="magnify"
                      autocomplete
                      open-on-focus
                      field="decorator.nomPrenom"
                      @typing="getFilteredValidateurTags"
                      @input="getValidateurTags">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.facture')">
          <b-input v-model="newCritereRecherche.codeAndReferenceFacture"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.theme')">
          <b-input v-model="newCritereRecherche.themeFacture"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.codeDossierFacture')">
          <b-input v-model="newCritereRecherche.codeDossierFacture"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="this.nomCommercial">
          <b-input v-model="newCritereRecherche.nomBailleur"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.montant')">
          <input-currency isNumber="true"
                          v-model="newCritereRecherche.montant">
          </input-currency>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listePaiementSurFacture.filtre.blocageReglement')">
          <b-select v-model="newCritereRecherche.blocageReglement">
            <option :value="null"></option>
            <option :value="true"> {{ $t('listePaiementSurFacture.filtre.yes') }}
            </option>
            <option :value="false"> {{ $t('listePaiementSurFacture.filtre.no') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeEcheancesAPayer.filtre.modeReglement')">
          <qd-taginput v-if="modeReglementTags"
                      v-model="modeReglementSelected"
                      :data="modeReglementTags"
                      type="is-primary"
                      icon="magnify"
                      autocomplete
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredModeReglementTags"
                      @input="getModeReglementTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="agencesSelectionnees.length > 1">
        <agence-tag-input
                      :label="$t('listePaiementSurFacture.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesIds">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('listePaiementSurFacture.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('listePaiementSurFacture.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  SET_CRITERE_RECHERCHE,
} from '@/store/modules/baux/paiementSurFacture-mutation-type';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import inputCurrency from '@/components/general/inputCurrency';
import genererCritereRecherchePaiementSurFacture
  from '@/services/baux/echeancesAPayer/genererCritereRecherchePaiementSurFacture';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import { MODULE_TLPE, MODULE_BAIL, MODULE_ACHAT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const PaiementSurFacture = createNamespacedHelpers('paiementSurFacture');

export default {
  props: {
    moduleDcf: String,
  },
  data() {
    return {
      errors: [],
      hasError: false,
      newCritereRecherche: null,
      validateurSelected: [],
      validateurTags: null,
      listeValidateurBase: null,
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
    };
  },
  components: {
    errorMsgComponent,
    inputCurrency,
    agenceTagInput,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...PaiementSurFacture.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    closeErrorMsg() {
      this.errors = [];
      this.hasError = false;
    },
    appliquerCritere() {
      this.newCritereRecherche.validateurs = this.validateurSelected.map((validateur) => {
        return validateur.id;
      });
      this.newCritereRecherche.modesReglementsIds = this.modeReglementSelected.map((mReglement) => {
        return mReglement.id;
      });
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche');
    },
    viderCritere() {
      this.newCritereRecherche = genererCritereRecherchePaiementSurFacture();
      this.validateurSelected = [];
      this.modeReglementSelected = [];
      this.getValidateurTags();
      this.getModeReglementTag();
    },
    getValidateurTags() {
      this.validateurTags = this.listeValidateurBase.filter((validateur) => {
        return !this.validateurSelected.map(v => v.id).includes(validateur.id);
      });
    },
    getFilteredValidateurTags(text) {
      this.getValidateurTags();
      this.validateurTags = this.validateurTags.filter((validateur) => {
        return validateur.decorator.nomPrenom.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametreUtilisateur();
        await this.loadParametres([
          PARAMETRES_KEYS.modeReglement,
        ]);

        this.listeValidateurBase = this.users;
        if (this.newCritereRecherche.validateurs) {
          this.validateurSelected = this.listeValidateurBase.filter((validateur) => {
            return this.newCritereRecherche.validateurs.includes(validateur.id);
          });
        }
        this.getValidateurTags();

        this.listeModeReglementBase = this.modesReglement;
        if (this.newCritereRecherche.modesReglementsIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.newCritereRecherche.modesReglementsIds.includes(modeReglemnt.id);
          });
        }
        this.getModeReglementTag();

        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
    ...PaiementSurFacture.mapGetters({
      critereRechercheFromStore: 'critereRecherche',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur)
        .filter(u => u.actif);
    },
    nomCommercial() {
      switch (this.moduleDcf) {
        case MODULE_TLPE:
          return this.$t('listePaiementSurFacture.filtre.nomCollectivite');
        case MODULE_BAIL:
          return this.$t('listePaiementSurFacture.filtre.nomBailleur');
        case MODULE_ACHAT:
          return this.$t('listePaiementFactureAchat.filtre.nomFournisseur');
        default:
          return this.$t('listePaiementSurFacture.filtre.nomBailleur');
      }
    },
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
